import * as React from "react";
import {
  FormatClearRounded,
  FormatStrikethroughRounded,
  FormatUnderlinedRounded,
} from "@mui/icons-material";
import { TXGUISection } from "../../interfaces/gui/fields.interfaces";
import { ELEMENTS_GUI_FIELDS } from "./elements.settings";
import { MAIN_COLOR } from "../../constants/common/utils";

const { "Thème & Couleurs": THEME, ...rest } = ELEMENTS_GUI_FIELDS;

export const X_BREADCRUMB_GUI_FIELDS: TXGUISection = {
  Général: [
    {
      type: "toggle_option",
      name: "showHomeIcon",
      label: "Afficher l'Icone",
      options: [
        { value: false, label: "Non" },
        { value: true, label: "Oui" },
      ],
      defaultValue: false,
    },
    {
      type: "toggle_option",
      name: "showHomeLabel",
      label: "Afficher le Label",
      options: [
        { value: false, label: "Non" },
        { value: true, label: "Oui" },
      ],
      defaultValue: true,
    },
    {
      type: "toggle_option",
      name: "separator",
      label: "Separateur",
      options: [{ value: "›", label: ">" }, { value: "/" }],
      defaultValue: "/",
    },
  ],
  "Thème & Couleurs": [
    ...(THEME ?? []),
    // {
    //   type: "font",
    //   name: "fontFamily",
    //   label: "Police",
    //   defaultValue: "inherit",
    // },
    {
      type: "sizing",
      name: "fontSize",
      label: "Taille de la police",
      placeholder: "10",
      units: ["px", "em", "rem", "pt"],
    },
    {
      type: "select_option",
      name: "fontWeight",
      label: "Epaisseur de la police",
      options: [
        { value: 100, label: "Mince" },
        { value: 200, label: "Tres Léger" },
        { value: 300, label: "Léger" },
        { value: 400, label: "Normal" },
        { value: 500, label: "Moyen" },
        { value: 600, label: "Semi-gras" },
        { value: 700, label: "Gras" },
        { value: 800, label: "Extra Gras" },
        { value: 900, label: "Lourd" },
      ],
      defaultValue: 400,
    },
    {
      type: "color",
      name: "textColor",
      label: "Couleur du texte",
      defaultValue: "#000000",
    },
    {
      type: "color",
      name: "linkColor",
      label: "Couleur du Lien",
      defaultValue: MAIN_COLOR,
    },
    {
      type: "toggle_option",
      name: "linkDecoration",
      label: "Decoration du Lien",
      options: [
        { value: "none", label: "Aucune", icon: <FormatClearRounded /> },
        {
          value: "underline",
          label: "Souligner",
          icon: <FormatUnderlinedRounded />,
        },
        {
          value: "line-through",
          label: "Barrer",
          icon: <FormatStrikethroughRounded />,
        },
      ],
      defaultValue: "none",
    },
  ],
  Survolés: [
    {
      type: "color",
      name: "linkHoverColor",
      label: "Couleur du Lien",
    },
    {
      type: "toggle_option",
      name: "linkHoverDecoration",
      label: "Decoration du Lien",
      options: [
        { value: "none", label: "Aucune", icon: <FormatClearRounded /> },
        {
          value: "underline",
          label: "Souligner",
          icon: <FormatUnderlinedRounded />,
        },
        {
          value: "line-through",
          label: "Barrer",
          icon: <FormatStrikethroughRounded />,
        },
      ],
      defaultValue: "none",
    },
  ],
  ...rest,
};
